export default __webpack_public_path__ + "static/media/com-ross.ae44ba83.mp4";